import { cn } from '@/utils/utils';
import React from 'react';

export interface TextareaProps
    extends React.TextareaHTMLAttributes<HTMLTextAreaElement> { }

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
    ({ className, ...props }, ref) => {
        return (
            <textarea
                className={cn(
                    'flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-input-1 text-sm ring-offset-background placeholder:text-placeholder-1 focus-visible:outline-none focus-visible:border-active disabled:cursor-not-allowed disabled:opacity-50',
                    className
                )}
                autoFocus={false}
                ref={ref}
                {...props}
            />
        );
    }
);
Textarea.displayName = 'Textarea';

export { Textarea };
